import { action } from './index'
import {
  COUPONS_FETCH_ERROR,
  CONTESTS_FETCH_SUCCESS,
  COUPONS_FETCH_REQUEST,
} from './constants'
import { Coupon } from '../reducers/coupons'

export const couponsFetchRequest = () => {
  return action(COUPONS_FETCH_REQUEST)
}

export const couponsFetchSuccess = (payload: Coupon[]) => {
  return action(CONTESTS_FETCH_SUCCESS, payload)
}

export const couponsFetchError = () => {
  return action(COUPONS_FETCH_ERROR)
}

export type CouponsActions = ReturnType<
  | typeof couponsFetchRequest
  | typeof couponsFetchSuccess
  | typeof couponsFetchError
>
